import { bridge } from '../../bridge';
import DeviceInfo from '../../DeviceInfo';
import { getWebBaseURL } from '../../getWebBaseURL';
import { isIOS } from '../../isIOS';

export const moveToWebview = async (
  path: keyof typeof WEBVIEW_PAGE,
  { titleBar = false }: MoveToWebviewOptions = {},
) => {
  const pagePath = WEBVIEW_PAGE[path];
  if ((await DeviceInfo.getVersion()) === '2.334.0' && isIOS) {
    const changedDeeplink = `ably://webview?title_bar=${titleBar}&url=https://m.a-bly.com${pagePath}`;
    bridge.openDeeplink(changedDeeplink, {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        location.href = `${baseURL}${pagePath}`;
      },
    });
    return;
  }

  bridge.openDeeplink(`ably://webview?title_bar=${titleBar}&url=${pagePath}`, {
    webCallback: async () => {
      const baseURL = await getWebBaseURL();
      location.href = `${baseURL}${pagePath}`;
    },
  });
};

type MoveToWebviewOptions = {
  titleBar?: boolean;
};

const WEBVIEW_PAGE = {
  /** - 장바구니로 이동 */
  Cart: '/cart?from=CARTICON',
  /** - AI 옷입히기 생성 페이지로 이동 */
  CreateOutfitTryOn:
    '/content/fitting-rooms/outfit-try-on/create?conceptId%3D1%26categoryChipKey%3DrecentlyViewed%26entryPoint%3DRECENTLY_VIEWED_GOOD',
  /** - 이용약관 */
  TermsOfUse: '/agreement/terms-of-use',
  /** - 개인정보 처리방침 */
  Privacy: '/agreement/privacy',
  /** - 청소년 보호정책 */
  YouthPolicy: '/youth-policy',
} satisfies Record<string, `/${string}`>;
